import { StorageReference } from '@angular/fire/storage';
import { FileExtra } from '@ih/app/client/shared/interfaces';

export class ShowDeleteConfirmationAction {
  public static readonly type =
    '[Project/Storage/List] ShowDeleteConfirmationAction';
  constructor(public readonly file: StorageReference & FileExtra) {}
}
